export default {"href":"/corgi/pageapps/purchase/_next/public/sprite-3.46.0-a74e71f86.svg#assortment-2","viewBox":"0 0 20 16"}